import axios from 'axios';
import api from './ManageDatabaseReq';

export default axios.create({
    baseURL: `${api.defaults.baseURL}sensor/`
});